<template>
    <Teleport :to="to" :disabled="! enabled">
        <slot></slot>
    </Teleport>
</template>

<script lang="ts">
export default {
    name: "FilterPortal",

    data() {
        return {
            enabled: false,
            to: null,
            boundMethods: {
                activate: () => {
                    // Only do this when the page is in desktop mode.
                    if (window.innerWidth >= 1024) {
                        this.enabled = true;
                        this.to = '.filter-portal';
                    }

                    // this.Bus.emit('update-render-mode', 'filter-only');
                },
                revert: () => {
                    this.enabled = false;
                    this.to = null;
                    // this.Bus.emit('update-render-mode', 'render');
                    // this.Bus.emit('filter-change');
                }
            }
        }
    },

    mounted() {
        this.Bus.on('filter-portal-activate', this.boundMethods.activate);
        this.Bus.on('filter-portal-revert', this.boundMethods.revert);
    },

    unmounted() {
        this.Bus.off('filter-portal-activate', this.boundMethods.activate);
        this.Bus.off('filter-portal-revert', this.boundMethods.revert);
    }
};
</script>

<style>
.filter-portal .distance-slider-filter {
    display: none;
}
</style>
